import React from "react";
import ReactDOM from "react-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import App from "./components/App";
import appConfig from "./data/appConfig";

// update Page Title
const siteTitle = appConfig["siteSet"]["title"];
const appTitle = appConfig["appSet"]["titleC"];
const pageTitle = appTitle + " - " + siteTitle;
document.getElementsByTagName("TITLE")[0].text = pageTitle;

ReactDOM.render(<App />, document.getElementById("root"));
<script type="module" src="./index.js"></script>;
